import { selectedBankId } from '@/stores/banks'
import { checkoutApi } from '@/api'
import { order, orderHash } from '@/stores/Order'
import {ecommerceBeginCheckout, ecommercePurchase} from '@/utils/analytics'

export async function checkout() {
  try {
    if (!orderHash.value || !selectedBankId.value) {
      return {
        success: false,
      }
    }

    if(order.value){
      const products  = [
        {
          id: order.room_id,
          name: order.room_name,
          price: order.room_price,
          discountPrice: 0,
          vat: 0,
          quantity: 1,
        }
      ]
      order.value.services.forEach(service => {
        products.push({
          id: service.service_item_id ? `${service.service_id}_${service.service_item_id}` : service.service_id,
          name: service.name,
          price: service.price,
          discountPrice: 0,
          vat: 0,
          quantity: service.amount || 1,
        })
      })
      ecommerceBeginCheckout({
        products: products
      })
    }

    const { success, redirect, message, transactionId } = await checkoutApi(
      orderHash.value,
      selectedBankId.value
    )

    if (success) {
      if(order.value){
          const products  = [
            {
              id: order.room_id,
              name: order.room_name,
              price: order.room_price,
              discountPrice: 0,
              vat: 0,
              quantity: 1,
            }
          ]
          order.value.services.forEach(service => {
            products.push({
              id: service.service_item_id ? `${service.service_id}_${service.service_item_id}` : service.service_id,
              name: service.name,
              price: service.price,
              discountPrice: 0,
              vat: 0,
              quantity: service.amount || 1,
            })
          })
          ecommercePurchase({
            products: products,
            transactionId: transactionId,
          })
        }

      if (redirect) {
        window.location.href = redirect
        return {
          redirecting: true,
          success,
          message,
        }
      } else {
        return {
          redirecting: false,
          success,
          message,
        }
      }
    }
    return {
      redirecting: false,
      success,
      message,
    }
  } catch (error) {
    console.error(error)
  }

  return {
    success: false,
  }
}
